import { useMemo } from 'react';
import { NODES_EXTRA_DATA, START_INITIAL_POSITION } from '../const';
import { StartNodeType } from '../nodes/start/types';
import { createNode } from '../utils';

export const useWorkflowTemplate = () => {
  const nodesInitialData = useMemo(() => NODES_EXTRA_DATA, []);

  const startNode = createNode<StartNodeType>({
    data: nodesInitialData.start.defaultData,
    position: START_INITIAL_POSITION,
  });

  // const NlpNode = createNode<NlpExtractNode>({
  //   data: nodesInitialData['nlp-extract'].defaultData,
  //   position: {
  //     x: START_INITIAL_POSITION.x + NODE_WIDTH_X_OFFSET,
  //     y: START_INITIAL_POSITION.y,
  //   },
  // });

  return {
    nodes: [startNode],
    edges: [],
  };
};
